import React, { Component } from "react";
import { withLocalize } from "react-localize-redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { SpinLoading } from "../../styles/BasicStyles";
import LongArrowLeft from "../../assets/icons/ic_arrow_left.svg";
import { GetContentByCategory, GetContentFile, GetNextWeddings } from "../../infra/requests/InformationRequests";
import DraftJSContent from "../../components/draftjs/DraftJSContent";
import Document from "../../components/document/Document";
import {
  DetailContent,
  DetailContainer,
  Title,
  BackButton,
  DocumentsSection,
  NextWeddingsTitle,
  Backdrop,
  DocumentPreview,
  Subtitle
} from "./InformationStyles";
import Slider from '../../components/slider/Slider';
import Wedding from "../../components/wedding/Wedding";
import ReactPlayer from "react-player";
import { GetExternalSuppliers, GetExternalSuppliersByCategory } from "../../infra/requests/ExternalSupplierCategoriesRequests";
import SelectInput from "../../components/inputs/SelectInput";
import { categories, categoriesKeys, getCategoriesByLanguage } from "../../components/staffCategory/Categories";
import { Col, Icon, Row } from "antd";
import ImageComponent from "../../components/images/ImageComponent";
import Logo from "../../assets/icons/logo_white_header.svg";
import HousesLogo from "../../assets/icons/houses.png";
import SupplierLogo from "../../assets/LOGO FINAL verde.png";
import { LogoContainer, LogoImg } from "../../components/header/HeaderStyles";
import ImageModal from "../../components/imageModal/ImageModal";
import EnlargeIcon from "../../components/svg/Enlarge";
import CategorySelectInput from "./CategorySelectInput";
import { SectionTitle } from "../reserve/ReserveStyles";

class InformationPageDetail extends Component {
  state = {
    loading: true,
    content: {},
    nextWeddings: [],
    documentLoading: false,
    videoLoading: false,
    externalSuppliersByCategory: [],
    isExternalSuppliers: false,
    externalSuppliers: [],
    selectedExternalSupplier: null,
    selectedStaffCategory: null,
    externalSuppliersOptions: [],
    showImageModal: false,
    selectedImage: null,
    isAccommodation: false
  };

  componentDidMount() {
    const { match: { params } } = this.props;

    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    document.body.style.overflowY = 'auto';

    if (params.id === '5c822fc9bd1ff815330bb48f') {
      this.setState({ isExternalSuppliers: true });
      this.getExternalSuppliers();
    }

    if (params.id === '5c822fb7bd1ff815330bb48e') {
      this.setState({ isAccommodation: true });
      this.getExternalSuppliersByCategory('ACCOMMODATION');
    }

    this.getContent();
  }

  getExternalSuppliers = async () => {
    const { history, match: { params }, activeLanguage } = this.props;

    const res = await GetExternalSuppliersByCategory(null);
    if (res?.success) {
      const externalSuppliersData = res?.data?.items || [];
      const externalSuppliersOptionsData = externalSuppliersData.map(supplier => {
        const category = supplier?.category;
        const categoryIndex = categoriesKeys.findIndex(c => c === category);
        if (categoryIndex === -1) {
          return;
        }

        const categoryName = categories[activeLanguage?.code][categoryIndex];

        return { _id: supplier?._id, name: `${supplier?.name} (${categoryName})` };
      });

      this.setState({ externalSuppliers: externalSuppliersData, externalSuppliersOptions: externalSuppliersOptionsData });
    }
  }

  getExternalSuppliersByCategory = async (category) => {
    const { history, match: { params }, activeLanguage } = this.props;

    const externalSuppliersRes = await GetExternalSuppliersByCategory(category);
    if (externalSuppliersRes?.success && externalSuppliersRes?.data) {
      this.setState({
        externalSuppliersByCategory: externalSuppliersRes?.data || [],
        selectedStaffCategory: category
      });
    }
  }

  getContent = async () => {
    const { history, match: { params }, activeLanguage } = this.props;

    const { data } = await GetContentByCategory(params.id);

    if (!data) {
      history.push('/404');
      return false;
    }

    if (data && data.link && data.link[activeLanguage.code]) this.setState({ documentLoading: true });
    if (data && data.videoLink && data.videoLink[activeLanguage.code]) this.setState({ videoLoading: true });

    let nextWeddings = [];
    if (data.category.tag === 'NEXT_EVENTS_DECORATION') {
      const res = await GetNextWeddings();

      if (res.success) {
        nextWeddings = res.data;
      }
    }

    this.setState({
      content: data,
      loading: false,
      nextWeddings
    });
  };

  handleIfrmeLoad = () => {
    // iframe loaded
    this.setState({ documentLoading: false });
    this.setState({ videoLoading: false });
  }

  handleSelectExternalSupplier = (value) => {
    this.setState({ selectedExternalSupplier: value });
  };

  handleSelectStaffCategory = async (value) => {
    this.setState({ loading: true });

    try {
      const externalSuppliersRes = await GetExternalSuppliersByCategory(value);
      if (externalSuppliersRes?.success && externalSuppliersRes?.data) {
        this.setState({
          externalSuppliersByCategory: externalSuppliersRes?.data || [],
          selectedStaffCategory: value,
          loading: false
        });
      } else {
        this.setState({ loading: false });
      }
    } catch (error) {
      this.setState({ loading: false });
    }
  }

  renderExternalSuppliers = () => {
    const { externalSuppliers, selectedExternalSupplier, showImageModal, selectedImage } = this.state;
    const { translate, activeLanguage } = this.props;

    if (!selectedExternalSupplier) return null;

    const supplier = externalSuppliers.find((s) => s._id === selectedExternalSupplier);

    if (!supplier) return null;

    const category = supplier?.category;
    const categoryIndex = categoriesKeys.findIndex(c => c === category);
    if (categoryIndex === -1) {
      return;
    }

    const categoryName = categories[activeLanguage?.code][categoryIndex];
    const images = supplier?.images || [];
    const supplierName = supplier?.name || '';

    return (
      <React.Fragment style={{ padding: '20px' }}>
        <DetailContainer style={{ backgroundColor: '#5e6b56ab' }}>
          <div style={{ padding: '20px', width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', marginBottom: '60px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <Title style={{ color: 'white', marginBottom: '10px' }}>{categoryName ?? ''}</Title>
                <Subtitle style={{ color: 'white' }}>{supplierName ?? ''}</Subtitle>
              </div>
              <LogoImg src={Logo} />
            </div>

            {images && images?.length > 0 && (<div style={{ display: 'flex', gap: '10px', marginTop: '40px', height: 250 }}>
              {images?.map((img, index) => {
                const isVertical = img?.orientation === 'vertical';
                return (
                  <div
                    key={index}
                    style={{
                      flex: isVertical ? 2 : 3,
                      height: '100%',
                      position: 'relative',
                      backgroundImage: `url(${img?.url})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundColor: img?.color || '#ece8e2',
                      cursor: 'pointer',
                      borderRadius: 4,
                      overflow: 'hidden'
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.setState({ showImageModal: true, selectedImage: img });
                    }}
                  >
                    <div style={{ position: 'absolute', top: 8, right: 8 }}>
                      <EnlargeIcon />
                    </div>
                  </div>
                );
              })}
            </div>)}

            {!images || images?.length === 0 && (
              <p style={{ textAlign: 'center', color: 'white', marginTop: '40px' }}>{translate('EXTERNAL_SUPPLIER_NO_GALLERY')}</p>
            )}

            <div style={{ marginTop: '20px', color: 'white', display: 'flex' }}>
              {supplier?.description?.[activeLanguage?.code] ?? supplier?.description?.['pt'] ?? ''}
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginTop: '20px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', color: 'white', flex: 1, justifyContent: 'center' }}>
                <Subtitle style={{ color: 'white' }}>{translate('CONTACT')}:</Subtitle>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', textAlign: 'left' }}>
                  <Icon type="mail" />
                  <div>{supplier?.email ?? ''}</div>
                </div>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', textAlign: 'left' }}>
                  <Icon type="phone" />
                  <div>{supplier?.contact ?? ''}</div>
                </div>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', textAlign: 'left' }}>
                  <Icon type="facebook" />
                  <div>{supplier?.facebook ?? ''}</div>
                </div>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', textAlign: 'left' }}>
                  <Icon type="instagram" />
                  <div>{supplier?.instagram ?? ''}</div>
                </div>
              </div>
              <LogoImg style={{ width: '100%', maxWidth: '200px' }} src={HousesLogo} />
            </div>
          </div>
        </DetailContainer>

        {showImageModal && (
          <ImageModal
            title={supplierName}
            image={selectedImage?.url}
            color={selectedImage?.color}
            handleCancel={() => this.setState({ showImageModal: false, selectedImage: undefined })}
          />
        )}
      </React.Fragment>
    );
  };

  renderExternalSuppliersByCategory = () => {
    const { externalSuppliers, selectedExternalSupplier, showImageModal, selectedImage, selectedStaffCategory, externalSuppliersByCategory } = this.state;
    const { translate, activeLanguage } = this.props;

    if (!selectedStaffCategory || !externalSuppliersByCategory || externalSuppliersByCategory?.length === 0) {
      return;
    }

    return (
      <React.Fragment style={{ padding: '20px' }}>
        {externalSuppliersByCategory.map((supplier, index) => {
          const images = supplier.images;
          const categoryName = supplier?.category;
          const supplierName = supplier?.name;

          return (
            <DetailContainer key={index} style={{ backgroundColor: '#9ca89a', marginBottom: '20px' }}>
              <div style={{ padding: '20px', width: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', marginBottom: '60px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <Title style={{ color: 'white', marginBottom: '10px' }}>{supplierName ?? ''}</Title>
                    {/* <Subtitle style={{ color: 'white' }}>{supplierName ?? ''}</Subtitle> */}
                  </div>
                  <LogoImg src={SupplierLogo} />
                </div>

                {images && images.length > 0 && (
                  <div style={{ display: 'flex', gap: '10px', marginTop: '40px', height: 250 }}>
                    {images.map((img, imgIndex) => {
                      const isVertical = img?.orientation === 'vertical';
                      return (
                        <div
                          key={imgIndex}
                          style={{
                            flex: isVertical ? 2 : 3,
                            height: '100%',
                            position: 'relative',
                            backgroundImage: `url(${img?.url})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundColor: img?.color || '#ece8e2',
                            cursor: 'pointer',
                            borderRadius: 4,
                            overflow: 'hidden'
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.setState({ showImageModal: true, selectedImage: img });
                          }}
                        >
                          <div style={{ position: 'absolute', top: 8, right: 8 }}>
                            <EnlargeIcon />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {!images || images.length === 0 && (
                  <p style={{ textAlign: 'center', color: 'white', marginTop: '40px' }}>
                    {translate('EXTERNAL_SUPPLIER_NO_GALLERY')}
                  </p>
                )}

                <div style={{ marginTop: '20px', color: 'white', display: 'flex' }}>
                  {supplier?.description?.[activeLanguage?.code] ?? supplier?.description?.['pt'] ?? ''}
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginTop: '20px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', color: 'white', flex: 1, justifyContent: 'center' }}>
                    <Subtitle style={{ color: 'white' }}>{translate('CONTACT')}:</Subtitle>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', textAlign: 'left', height: '20px', marginBottom: '5px' }}>
                      <Icon type="mail" />
                      <div>{supplier.email ?? ' '}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', textAlign: 'left', height: '20px', marginBottom: '5px' }}>
                      <Icon type="phone" />
                      <div>{supplier.contact ?? ' '}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', textAlign: 'left', height: '20px', marginBottom: '5px' }}>
                      <Icon type="facebook" />
                      <div>{supplier.facebook ?? ' '}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', textAlign: 'left', height: '20px', marginBottom: '5px' }}>
                      <Icon type="instagram" />
                      <div>{supplier.instagram ?? ' '}</div>
                    </div>
                  </div>
                  {/* <LogoImg style={{ width: '100%', maxWidth: '200px' }} src={HousesLogo} /> */}
                </div>
              </div>
            </DetailContainer>
          );
        })}

        {showImageModal && (
          <ImageModal
            title={''}
            image={selectedImage?.url}
            color={selectedImage?.color}
            handleCancel={() => this.setState({ showImageModal: false, selectedImage: undefined })}
          />
        )}
      </React.Fragment>
    );
  };

  render() {
    const { isExternalSuppliers, externalSuppliersOptions, selectedExternalSupplier, selectedStaffCategory, isAccommodation } = this.state;
    const { translate, history, activeLanguage } = this.props;
    const { content, nextWeddings, loading, documentLoading, videoLoading } = this.state;
    const documentLink = content && content.link && content.link[activeLanguage.code] ?
      content.link[activeLanguage.code].includes('drive.google.com') &&
        content.link[activeLanguage.code].includes('/view')
        ? content.link[activeLanguage.code].replace('/view', '/preview')
        : content.link[activeLanguage.code]
      : null;

    const videoLink = content && content.videoLink && content.videoLink[activeLanguage.code] ?
      content.videoLink[activeLanguage.code].includes('drive.google.com') &&
        content.videoLink[activeLanguage.code].includes('/view')
        ? content.videoLink[activeLanguage.code].replace('/view', '/preview')
        : content.videoLink[activeLanguage.code]
      : null;

    if (loading) return <SpinLoading />;

    return (
      <DetailContent>
        <DetailContainer>
          <BackButton
            src={LongArrowLeft}
            onClick={() => history.push("/information")}
          />
          <Title>{translate(content?.category?.tag || "")}</Title>
          <DraftJSContent content={content?.text} />
          {documentLink && <React.Fragment>
            {/* <Subtitle>{translate("DOCUMENT")}</Subtitle> */}
            <DocumentPreview>
              {documentLoading && <Backdrop>
                <SpinLoading style={{ position: 'absolute', minHeight: 30 }} />
              </Backdrop>}
              <iframe
                id="document"
                onLoad={this.handleIfrmeLoad}
                style={{ width: '100%', height: 500, borderRadius: 5, borderWidth: 1 }}
                src={documentLink}
              ></iframe>
            </DocumentPreview>
          </React.Fragment>
          }
          {videoLink && <React.Fragment>
            {/* <Subtitle>{translate("VIDEO")}</Subtitle> */}
            <DocumentPreview>
              {videoLoading && <Backdrop>
                <SpinLoading style={{ position: 'absolute', minHeight: 30 }} />
              </Backdrop>}
              <iframe
                id="document"
                onLoad={this.handleIfrmeLoad}
                style={{ width: '100%', height: 500, borderRadius: 5, borderWidth: 1 }}
                src={videoLink}
                autoplay={0}
                controls
                allowFullScreen
              ></iframe>
            </DocumentPreview>
          </React.Fragment>
          }
        </DetailContainer>
        {
          content.gallery && content.gallery.length > 0 &&
          <Slider gallery={content.gallery} />
        }
        <DetailContainer>
          {content?.files && content.files.length > 0 && (
            <DocumentsSection>
              {content.files.map(file => (
                <Document key={file._id} document={file} />
              ))}
            </DocumentsSection>
          )}
        </DetailContainer>
        {
          nextWeddings.length > 0 &&
          <DetailContainer>
            <NextWeddingsTitle>{translate('NEXT_WEDDINGS')}</NextWeddingsTitle>
            {
              nextWeddings.map((wedding, index) =>
                <Wedding key={index} wedding={wedding} />
              )
            }
          </DetailContainer>
        }

        {isExternalSuppliers && <React.Fragment>
          <DetailContainer style={{ marginBottom: '40px' }}>
            <Subtitle>{translate('EXTERNAL_SUPPLIER')}</Subtitle>
            <CategorySelectInput
              placeholder={translate('SELECT_OPTION')}
              data={getCategoriesByLanguage(activeLanguage?.code)}
              dataKey={'_id'}
              dataLabel={'name'}
              meta={{}}
              input={{
                value: selectedStaffCategory,
                onChange: this.handleSelectStaffCategory,
              }}
              onClick={() => { }}
              readOnly={false}
            />
            {/* <SelectInput
              placeholder={translate('SELECT_OPTION')}
              data={externalSuppliersOptions}
              dataKey={'_id'}
              dataLabel={'name'}
              meta={{}}
              input={{
                value: selectedExternalSupplier,
                onChange: this.handleSelectExternalSupplier,
              }}
              onClick={() => { }}
              readOnly={false}
            /> */}
          </DetailContainer>
        </React.Fragment>}

        {/* {isExternalSuppliers && this.renderExternalSuppliers()} */}
        {isExternalSuppliers && this.renderExternalSuppliersByCategory()}

        {isAccommodation && <React.Fragment>
          <DetailContainer style={{ marginTop: '40px' }}>
            <Subtitle style={{ fontSize: '28px' }}>{translate('SUPPLIERS')}</Subtitle>
            {this.renderExternalSuppliersByCategory()}
          </DetailContainer>
        </React.Fragment>}
      </DetailContent >
    );
  }
}

const mapStateToProps = state => ({
  categories: state.info.content_categories || []
});

export default withRouter(withLocalize(connect(mapStateToProps)(InformationPageDetail)));